import * as React from "react";
import LiquorImg from "../liquor-img";
import MadeInAlberta from "../made-in-alberta";
import ProductDetails from "../product-details";
import CONSTS from "../../consts";
const IconChevron = require('!svg-react-loader?name=LiquorIcon!../../../wwwroot/img/icons/icon-chevron.svg');
// interface FeaturedProductStates  {
//     featuredProducts:any
// }
export default class FeaturedProducts extends React.Component {
    constructor(props) {
        super(props);
        // this.state = {
        //     featuredProducts: null
        // };
    }
    // componentWillReceiveProps(nextProps:FeaturedProductsProps) {
    //     if (nextProps.supplier !== this.props.supplier) {
    //         this.getFeaturedProducts(nextProps.supplier);
    //     }
    // }
    render() {
        let products = this.props.featuredProducts;
        // Dirty way to trim whitespacing
        products = JSON.parse(JSON.stringify(products).replace(/"\s+|\s+"/g, '"'));
        return (React.createElement("div", null, products.length > 0 &&
            React.createElement("div", { className: "store-template-b__products" },
                React.createElement("div", { className: "store-template-b__products__wrap" },
                    React.createElement("div", { className: "featured-products__grid" }, products.map((product, index) => {
                        var priceSet = null;
                        if (product.Price) {
                            priceSet = product.Price.toString().split('.');
                        }
                        let cents = priceSet ? priceSet[1] : '';
                        let dollar = priceSet ? priceSet[0] : '';
                        return React.createElement("div", { key: index, className: "list-item" },
                            React.createElement("div", { className: "list-item__image" },
                                React.createElement(MadeInAlberta, { madeInAlberta: product.Product.MadeInAlberta }),
                                React.createElement(LiquorImg, { src: `${CONSTS.STORAGEURL}/${CONSTS.PRODUCTCONTAINER}/${product.Product.SKU}.jpg` })),
                            React.createElement("div", { className: "list-item__details" },
                                React.createElement("div", { className: "list-item__details__name" },
                                    React.createElement("h4", null, product.Product.Name),
                                    React.createElement("div", { className: "pricing" },
                                        React.createElement("span", null,
                                            React.createElement("sup", { hidden: !product.Price }, "$"),
                                            dollar,
                                            React.createElement("sup", null, cents)))),
                                React.createElement(ProductDetails, { product: product.Product })));
                    }))))));
    }
}
;
//# sourceMappingURL=featured-products.js.map